import React from "react";
import BaseAlert from "./BaseAlert";

function Alert() {
  return <BaseAlert />;
}

export default Alert;
